// issue #162: ユーザ要望フォームの連投防止 (クールダウン)。
// localStorage に最終送信時刻 (epoch ms) を記録し、一定時間内の再送信をブロックする。
// backend のレート制限ではなくクライアント側の簡易制限。now を注入可能にしてテストを決定化する。

export const FEEDBACK_LAST_SUBMIT_KEY = 'omakase-unshi:feedback-last-submit';

/** 連投防止クールダウン (ms)。この時間内の再送信はブロックする。 */
export const FEEDBACK_THROTTLE_MS = 60_000;

/** 最終送信時刻 (epoch ms)。未設定 / 壊れた値は 0 (= 未送信扱い)。 */
export function getLastSubmit(): number {
  if (typeof window === 'undefined') return 0;
  const raw = window.localStorage.getItem(FEEDBACK_LAST_SUBMIT_KEY);
  if (!raw) return 0;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

/** 最終送信時刻を記録する。省略時は現在時刻 (Date.now)。 */
export function setLastSubmit(ts?: number): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(FEEDBACK_LAST_SUBMIT_KEY, String(ts ?? Date.now()));
}

/** 前回送信から FEEDBACK_THROTTLE_MS 未満なら true (送信ブロック)。now は注入可能。 */
export function isThrottled(now?: number): boolean {
  const current = now ?? Date.now();
  return current - getLastSubmit() < FEEDBACK_THROTTLE_MS;
}
